const project_description_for_console = function () {
  console.group("About Boom_fx_max");
  console.log(`Boom_fx_max, by Stephen Boyd  
August, 2022  
Little India, Toronto, Canada.

fxhash: ${fxhash}
Organizing Principle Ratio: ${window.$fxhashFeatures["The Organizing Principle Ratio"]}
Aspect Ratio: ${window.$fxhashFeatures["Aspect Ratio"]}
Colour Palette: ${window.$fxhashFeatures["Colour Palette"]}`);

  console.group("Project Description");
  console.log(`This is a follow-up to Boom_fx and a free mint for anyone who is a holder of Boom_fx as of August 29, 2022, 00:11:00Z. 

Boom_fx_max uses all eleven days of data in one image. This constitutes 4,567 earthquakes being represented in every output. This differs from the original Boom_fx which used hours of time on one of the eleven days and typically included a few hundred seismic events.

There are eleven new colour palettes and seven different ratios to organize relationships between visual elements.

The earthquake data comes from the USGS API which very handily provides GeoJSON files. There is further documentation (./documentation/Information_about_boom_fx_max.md) included with this project that outlines how this data was collected and the information included in these feeds.`);

  console.groupEnd();

  console.groupCollapsed("Appreciation");
  console.log(`Thank you to everyone who has collected one my pieces.

Thank you to the USGS for making this data available.

And thank you the most to KIRH.`);
  console.groupEnd();

  console.groupCollapsed("Keyboard Controls - Exporting to PNG");
  console.log(`Export to a PNG format at several different sizes.

- Press t: thumbnail @ a maximum pixel width or height of 200px
- Press s: your current screen size
- Press p: print size @ a maximum pixel width or height of 4800px which is 16"@300dpi
- Press h: HD4K on the vertical @ a maximum pixel width or height of 2160px
- Press m: Max size @ a maximum pixel width or height of 10800px. This is a biiiig size

The filename will include some metadata such as the unique hash, date and time at time of capture.`);
  console.groupEnd();

  console.groupCollapsed(
    `Software Libraries and other technology used for development`
  );
  console.log(`Software Libraries:
Made with Processing / P5.js  
p5.js v1.4.1 February 02, 2022

Hardware used for development:
MacBook Pro (13-inch, 2019)

Version Control:
https://github.com/sspboyd/boom_fx_max

This repo is private as of August 2022. However, I have provided a source map with this project so please feel free to browse the code and see how it all works. There are a number of comments in the code explaining what is happening at different points.`);

  console.groupEnd();
  console.groupCollapsed(`Tags`);
  console.log(
    `Boom_fx_max, USGS, generative, code, geometry, geometric, generativeart, processing, p5js, 2d, abstract, colour, color, math, maths, cryptoart, substrate, sspboyd, Stephen_Boyd, fxhash, IPFS, Boom_01`
  );
  console.groupEnd();

  console.group(`License information`);
  console.log(`See LICENSE.md
This work is licensed under a Creative Commons
Attribution-NonCommercial-NoDerivatives 4.0 International License
http://creativecommons.org/licenses/by-nc-nd/4.0/

NFT Art and Code copyright Stephen Boyd`);
  console.groupEnd();
  console.groupCollapsed("About Stephen Boyd");
  console.log(`I live and work in the community of Little India in Toronto, Ontario, Canada.

I've been working with Processing and now P5.js to create generative art since 2004.

I am drawn to projects where I can use data as a substrate for expressing the details and relationships within the data.

My process is to sketch ideas to paper first as logic statements combined with visual relationships and then build the code up from there. I typically don't know what the visual outputs will become before the first test render.

I'm self-taught (no formal art or comp sci education) so I can proudly claim all mistakes are mine alone.

In my experience, the best outputs come from the first buggy renders before I can get in there to tweak and 'fix' things.

- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- GitHub, https://github.com/sspboyd
- Twitter, https://twitter.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Twitch.tv, https://www.twitch.tv/sspboyd
- Email: stephen@sspboyd.ca`);
  console.groupEnd();
  console.groupCollapsed("Contact Info");
  console.log(`- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- GitHub, https://github.com/sspboyd
- Twitter, https://twitter.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Email: stephen@sspboyd.ca
`);
  console.groupEnd("Contact Info");

  console.groupEnd();
};

export { project_description_for_console };
